<script setup lang="ts">
withDefaults(defineProps<{
  modelValue: boolean
  title: string
  subtitle?: string
  width?: string
  closeOnClickModal?: boolean
}>(), {
  width: '620px',
  closeOnClickModal: false,
})

const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()
</script>

<template>
  <el-dialog
    class="ui-dialog"
    :model-value="modelValue"
    :width="width"
    :close-on-click-modal="closeOnClickModal"
    :destroy-on-close="true"
    align-center
    append-to-body
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #header>
      <div class="drawer-head">
        <div class="drawer-head__text">
          <div class="drawer-title">{{ title }}</div>
          <div v-if="subtitle" class="drawer-sub">{{ subtitle }}</div>
        </div>
        <slot name="head-extra" />
      </div>
    </template>
    <slot />
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </el-dialog>
</template>
